/**
 * CampaignTracker — mounts the first-party funnel tracker and fires a
 * page_view on every public route change. Skips authenticated app surfaces
 * (the tracker util enforces the same guard). Fail-soft.
 */
import { useEffect, useRef } from 'react';
import { useLocation } from 'react-router-dom';
import { initCampaignTracking, trackPageView } from '@/utils/campaignTracking';

export default function CampaignTracker() {
  const { pathname, search } = useLocation();
  const ready = useRef(false);

  useEffect(() => {
    // First mount performs init (which also fires the initial page_view).
    if (!ready.current) {
      ready.current = true;
      initCampaignTracking();
      return;
    }
    if (pathname.startsWith('/app') || pathname.startsWith('/tech-admin') || pathname.startsWith('/corvana-crm')) return;
    trackPageView();
  }, [pathname, search]);

  return null;
}
